class ScrollingImage {
  constructor() {
    this.section = document.getElementById('testimonials-section');
    this.imageContainer = document.getElementById('custom-logo-id');
    this.image = this.imageContainer.querySelector('img');

    this.initEventListeners();
  }

  initEventListeners() {
    document.addEventListener('scroll', () => this.handleScroll());
  }

  handleScroll() {
    const sectionPosition = this.section.getBoundingClientRect();
    if (sectionPosition.top < window.innerHeight && sectionPosition.bottom > 0) {
      const displacement = Math.max(0, window.innerHeight - sectionPosition.top);
      const movementFactor = (displacement / window.innerHeight) * 700;

      // const rotation = window.scrollY;
      this.image.style.transform = `rotate(${movementFactor}deg)`;
    }
  }
}
